import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { MatDialog, MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.css']
})
export class AddAddressComponent {

  constructor(private userService: UserService, private snackBar: MatSnackBar, private dialog: MatDialog) { }

  onAddAddress(form: NgForm) {

    const data = new FormData();
    data.append('contactPerson', form.value.contactPerson);
    data.append('mobile', `+94${form.value.mobile}`);
    data.append('houseNo', form.value.houseNo);
    data.append('building', form.value.building || '--');
    data.append('street', form.value.street);
    data.append('city', form.value.city);

    this.userService.addAddress(data).subscribe(result => {
      if (result.success) {
        const localUser = localStorage.getItem('user');
        const jsonUser = JSON.parse(localUser);
        jsonUser.addresses = result.data.addresses;

        const user = JSON.stringify(jsonUser);
        localStorage.setItem('user', user);

        this.userService.setAddresses(result.data.addresses);
        this.dialog.closeAll();
        this.snackBar.open('Address added successfully', 'Dismiss', {
          duration: 3000
        })
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }
}
